"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DFDHeaders = void 0;
var DFDHeaders;
(function (DFDHeaders) {
    DFDHeaders["apiKey"] = "x-api-key";
    DFDHeaders["accept"] = "accept";
    DFDHeaders["audience"] = "mhp-token-audience";
    DFDHeaders["auditData"] = "x-audit-data";
    DFDHeaders["authorization"] = "authorization";
    DFDHeaders["cacheControl"] = "cache-control";
    DFDHeaders["caseId"] = "x-case-id";
    DFDHeaders["clinicalEventId"] = "x-clinical-event-id";
    DFDHeaders["consumerId"] = "x-dfd-consumer-id";
    DFDHeaders["contentId"] = "mhp-filter-content-id";
    DFDHeaders["contentType"] = "content-type";
    DFDHeaders["date"] = "mhp-filter-date";
    DFDHeaders["dfdEventId"] = "x-dfd-event-id";
    DFDHeaders["encounterId"] = "mhp-filter-encounter-id";
    DFDHeaders["eventIds"] = "mhp-filter-event-ids";
    DFDHeaders["fhirAuthToken"] = "x-fhir-auth-token";
    DFDHeaders["fhirType"] = "mhp-fhir-type";
    DFDHeaders["filterSource"] = "mhp-filter-source";
    DFDHeaders["gyantPatientId"] = "x-gyant-patient-id";
    DFDHeaders["inquiringPatientId"] = "x-user-patient-id";
    DFDHeaders["issuer"] = "mhp-token-issuer";
    DFDHeaders["kongApiKey"] = "apikey";
    DFDHeaders["loincCodes"] = "mhp-filter-loinc-codes";
    DFDHeaders["mhAzureMmi"] = "Dfd-Mmi";
    DFDHeaders["mhAzureUserId"] = "dfd-userId";
    DFDHeaders["mhpAdapter"] = "mhp-adapter";
    DFDHeaders["mhpAttachmentFileName"] = "mhp-attachment-filename";
    DFDHeaders["mhpAuditData"] = "mhp-audit-data";
    DFDHeaders["mhpAuthGuardResponse"] = "mhp-auth-guard-response";
    DFDHeaders["mhpCacheControl"] = "mhp-cache-control";
    DFDHeaders["mhpFilterAction"] = "mhp-filter-action";
    DFDHeaders["mhpFilterSubscriberId"] = "mhp-filter-subscriber-id";
    DFDHeaders["mhpGenPatientId"] = "mhp-gen-patient-id";
    DFDHeaders["mhpLanguageCode"] = "mhp-language-code";
    DFDHeaders["mhpMessageUuid"] = "mhp-message-uuid";
    DFDHeaders["mhpNVIdxPid"] = "mhp-nv-idx-pid";
    DFDHeaders["mhpProviderId"] = "mhp-provider-id";
    DFDHeaders["mhpTWmrn"] = "mhp-tw-mrn";
    DFDHeaders["mhpUmpiLinkId"] = "mhp-umpi-link-id";
    DFDHeaders["mobileDeviceId"] = "x-device-id";
    DFDHeaders["panelName"] = "mhp-filter-panel-name";
    DFDHeaders["patientId"] = "x-patient-id";
    DFDHeaders["preRegEventId"] = "x-prereg-event-id";
    DFDHeaders["requestId"] = "x-request-id";
    DFDHeaders["resourceId"] = "mhp-filter-resource-id";
    DFDHeaders["settingskey"] = "settingskey";
    DFDHeaders["targetPatientId"] = "x-target-patient-id";
    DFDHeaders["testResultCategory"] = "mhp-test-result-category";
    DFDHeaders["testResultName"] = "mhp-test-result-name";
    DFDHeaders["testResultNcid"] = "mhp-test-result-ncid";
    DFDHeaders["userAgent"] = "user-agent";
    DFDHeaders["webClientId"] = "x-forwarded-for";
})(DFDHeaders || (exports.DFDHeaders = DFDHeaders = {}));
//# sourceMappingURL=dfd-headers.enum.js.map